import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useOfferingCategories = () => {
  const urlStr = `${getApiUrl()}/offering-category`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useOfferingCategory = (id) => {
  const urlStr = `${getApiUrl()}/offering-category/${id}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostOfferingCategory = () => {
  const postOfferingCategory = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/offering-category`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postOfferingCategory;
};

export const usePutOfferingCategory = () => {
  const putOfferingCategory = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/mega/offering-category/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putOfferingCategory;
};
